import React, { useEffect, useRef, useState } from "react" // Imports ajoutés
import clsx from "clsx"
import {
     CONST_CANDIDATSUIVI_TYPE_BLACKLIST_NON_RECOMMANDE,
     CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT,
     CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CTS,
     CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE,
     CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR,
     CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE,
} from "@common-constants/*"

const FILTER_OPTIONS = [
     { id: CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR, label: "Repondeur", icon: "fa-phone-slash", color: "warning" },
     { id: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE, label: "DMS", icon: "fa-phone-alt", color: "primary" },
     { id: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CTS, label: "Pré-qualification", icon: "fa-eye", color: "info" },
     { id: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT, label: "RQ", icon: "fa-user-check", color: "success" },
]

const OTHER_OPTIONS = [
     { id: CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE, label: "Commentaire", icon: "fa-comment-alt" },
     { id: CONST_CANDIDATSUIVI_TYPE_BLACKLIST_NON_RECOMMANDE, label: "Blacklist", icon: "fa-ban" },
]

interface Props {
     activeFilters: string[]
     onToggle: (id: string) => void
     onClear: () => void
}

const CandidatSuiviFilterBar = ({ activeFilters, onToggle, onClear }: Props) => {
     // États et Références pour la gestion du clic extérieur
     const [isDropdownOpen, setIsDropdownOpen] = useState(false)
     const dropdownRef = useRef<HTMLDivElement>(null)

     const isOtherActive = OTHER_OPTIONS.some(opt => activeFilters.includes(opt.id))

     // Gestion de la fermeture lors d'un clic en dehors du composant
     useEffect(() => {
          const handleClickOutside = (event: MouseEvent) => {
               if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                    setIsDropdownOpen(false)
               }
          }

          document.addEventListener("mousedown", handleClickOutside)
          return () => {
               document.removeEventListener("mousedown", handleClickOutside)
          }
     }, [])

     return (
          <div className="d-flex flex-wrap gap-2 mb-6 justify-content-center pt-5">
               {/* Filtres principaux */}
               {FILTER_OPTIONS.map(opt => {
                    const isActive = activeFilters.includes(opt.id)
                    return (
                         <button
                              key={opt.id}
                              onClick={() => onToggle(opt.id)}
                              className={clsx(
                                   "btn btn-sm btn-outline btn-outline-dashed border-2 d-flex align-items-center",
                                   isActive ? `btn-active-light-${opt.color} active border-${opt.color}` : "btn-active-light-primary border-gray-300"
                              )}
                         >
                              <i className={clsx(`fas ${opt.icon} fs-4 me-2`, isActive ? `text-${opt.color}` : "text-gray-500")} />
                              <span className={clsx("fw-bold", isActive ? "text-gray-900" : "text-gray-600")}>{opt.label}</span>
                         </button>
                    )
               })}

               {/* Filtre "Autres" (Dropdown contrôlé manuellement) */}
               <div className="dropdown" ref={dropdownRef}>
                    <button
                         className={clsx(
                              "btn btn-sm btn-outline btn-outline-dashed border-2 d-flex align-items-center dropdown-toggle",
                              isOtherActive ? "btn-active-light-dark active border-dark" : "btn-active-light-primary border-gray-300",
                              isDropdownOpen && "show" // Classe Bootstrap pour l'état ouvert
                         )}
                         type="button"
                         onClick={() => setIsDropdownOpen(!isDropdownOpen)} // Bascule manuelle de l'état
                    >
                         <i className={clsx("fas fa-ellipsis-h fs-4 me-2", isOtherActive ? "text-dark" : "text-gray-500")} />
                         <span className={clsx("fw-bold", isOtherActive ? "text-gray-900" : "text-gray-600")}>Autres</span>
                    </button>
                    <ul
                         className={clsx("dropdown-menu shadow-sm", isDropdownOpen && "show")}
                         style={{ position: "absolute", inset: "0px auto auto 0px", margin: "0px", transform: "translate(0px, 40px)" }}
                    >
                         {OTHER_OPTIONS.map(opt => {
                              const isActive = activeFilters.includes(opt.id)
                              return (
                                   <li key={opt.id}>
                                        <button
                                             className={clsx("dropdown-item d-flex align-items-center py-3", isActive && "bg-light-primary")}
                                             onClick={() => {
                                                  onToggle(opt.id)
                                                  setIsDropdownOpen(false) // Fermer après sélection
                                             }}
                                        >
                                             <i className={clsx(`fas ${opt.icon} me-3 fs-6`, isActive ? "text-primary" : "text-gray-400")} />
                                             <span className={clsx("fw-bold", isActive ? "text-primary" : "text-gray-700")}>{opt.label}</span>
                                        </button>
                                   </li>
                              )
                         })}
                    </ul>
               </div>

               {activeFilters.length > 0 && (
                    <button onClick={onClear} className="btn btn-sm btn-link text-muted ms-2">
                         Tout voir
                    </button>
               )}
          </div>
     )
}

export default CandidatSuiviFilterBar
